import React from "react";
import { Routes, Route } from "react-router-dom";
import LoginForm from "./Auth/Login";
import Mainpage from "./Mainpage/Mainpage";
import EditProfile from "./Editprofile/main";
import AddTeacher from "./addteacher/AddTeacher";
import AllTeacher from "./allteacher/main";
import Editteacher from "./editteacher/main";
import AddStudent from "./addstudent/Addstudent";
import AllStudents from "./allstudents/main";
import EditStudent from "./editstudent/editstudent";
import AllCourses from "./allcourses/main";
import Addcourse from "./addcourse/AddCourse";
import EditCourse from "./editcourse/main";
import WelcomePage from "./welcomepage.js/Welcomepage";
import Attendance from "./Attendance/main";
import AttendanceList from "./Attendancelist/main";
import StudentCourses from "./studentcourses/main";
import StudentPayments from "./StudentPayments/main";
import FinancialBalance from "./FinancialBalance/main";
import ListOfDebtors from "./ListOfDebtors/allcourses";
import Debtors_list from "./ListOfDebtors/Debtors_list";
import MonthlyFinancialChart from "./FinancialBalance/monthly";
import YearlyFinancialChart from "./FinancialBalance/yearly";

function App() {
  return (
    <Routes>
      <Route path="/" element={<LoginForm />} />
      <Route path="/Mainpage" element={<Mainpage />}>
        <Route index element={<WelcomePage />} />
        <Route path="EditProfile" element={<EditProfile />} />
        <Route path="AddTeacher" element={<AddTeacher />} />
        <Route path="TeachersInf" element={<AllTeacher />} />
        <Route path="EditTeacher" element={<Editteacher />} />
        <Route path="AddStudent" element={<AddStudent />} />
        <Route path="StudentsInf" element={<AllStudents />} />
        <Route path="EditStudent" element={<EditStudent />} />
        <Route path="AddCourse" element={<Addcourse />} />
        <Route path="CoursesInf" element={<AllCourses />} />
        <Route path="EditCourse" element={<EditCourse />} />
        <Route path="Attendance" element={<Attendance />} />
        <Route path="AttendanceList" element={<AttendanceList />} />
        <Route path="StudentCourses" element={<StudentCourses />} />
        <Route path="StudentPayments" element={<StudentPayments />} />
        <Route path="FinancialBalance" element={<FinancialBalance />} />
        <Route path="FinancialBalance/Monthly" element={<MonthlyFinancialChart />} />
        <Route path="FinancialBalance/Yearly" element={<YearlyFinancialChart />} />
        <Route path="ListOfDebtors" element={<ListOfDebtors />} />
        <Route path="ListOfDebtors/:courseName" element={<Debtors_list />} />
      </Route>
    </Routes>
  );
}

export default App;

